import { useState } from "react";
import { useGetProductCategoryList } from "../../../../hooks/api/queries/useInventory";

const ProductCategoryLogic = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    isLoading,
    data: categories,
    refetch: refetchCategories,
  } = useGetProductCategoryList();

  return {
    isModalOpen,
    isLoading,
    categories: categories || [],
    refetchCategories,
    setIsModalOpen,
  };
};

export default ProductCategoryLogic;
